import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSlider from './components/HeroSlider';
import Services from './components/Services';
import About from './components/About';
import ClientLogos from './components/ClientLogos';
import Testimonials from './components/Testimonials';
import WebDevelopment from './pages/services/WebDevelopment';
import SocialMediaMarketing from './pages/services/SocialMediaMarketing';
import GraphicDesigning from './pages/services/GraphicDesigning';
import SEOServices from './pages/services/SEOServices';
import WhatsAppMarketing from './pages/services/WhatsAppMarketing';
import Advertisement from './pages/services/Advertisement';
import GoogleMyBusiness from './pages/services/GoogleMyBusiness';
import InfluencerMarketing from './pages/services/InfluencerMarketing';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PackagesPage from './pages/PackagesPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <HeroSlider />
              <Services />
              <About />
              <ClientLogos />
              <Testimonials />
            </>
          } />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/social-media-marketing" element={<SocialMediaMarketing />} />
          <Route path="/services/graphic-designing" element={<GraphicDesigning />} />
          <Route path="/services/seo-services" element={<SEOServices />} />
          <Route path="/services/whatsapp-marketing" element={<WhatsAppMarketing />} />
          <Route path="/services/advertisement" element={<Advertisement />} />
          <Route path="/services/google-my-business" element={<GoogleMyBusiness />} />
          <Route path="/services/influencer-marketing" element={<InfluencerMarketing />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/packages" element={<PackagesPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
